var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-select',{attrs:{"label":_vm.label,"name":_vm.name,"no_selection":_vm.no_selection,"options":_vm.states,"value":_vm.value,"read_only":_vm.read_only}})
}
var staticRenderFns = []

export { render, staticRenderFns }